import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

import _ from "lodash";
import { environment } from "../../../../../environments/environment";
@Component({
	selector: "FileApp",
	templateUrl: "./FileApp.component.html",
	styleUrls: ["./FileApp.component.scss"],
})
export class FileApp implements OnInit {
	@Output() onDeleteFile = new EventEmitter();

	@Input() displayFiles: any = [];
	@Input() deletable = false;
	@Input() disabled = false;

	LODASH = _;
	selectedFile = null;
	installer = "sparks-bme";
	installerFolder = "installer";

	constructor(private sanitizer: DomSanitizer) {}

	ngOnInit(): void {
		switch (environment.ENV) {
			case "dev": {
				this.installer = "sparks-bme-dev";
				this.installerFolder = "installer-dev";
				break;
			}
			case "uat": {
				this.installer = "sparks-bme-uat";
				this.installerFolder = "installer-uat";
				break;
			}
			case "staging": {
				this.installer = "sparks-bme-staging";
				this.installerFolder = "installer-staging";
				break;
			}
		}
	}

	ngOnChanges() {
		if (!this.displayFiles || _.isEmpty(this.displayFiles)) {
			this.displayFiles = [];
		}
	}

	deleteFile() {
		this.onDeleteFile.emit({ file: this.selectedFile });
	}

	getFileUrl(file: any) {
		if (file.category === "android") {
			return (
				environment.BE_URL +
				"?url=" +
				environment.AZURE_BLOB +
				"/" +
				file.file_name
			);
		} else if (file.category === "ios") {
			return this.sanitize(
				"itms-services://?action=download-manifest&url=" +
					environment.BASE_URL +
					"/assets/" +
					this.installerFolder +
					"/" +
					this.installer +
					".plist"
			);
		}
		return file.url; // Fallback to the URL from the response
	}

	sanitize(url: string) {
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}
}
